module.exports = __webpack_public_path__ + "img/5.f3d476b3.jpg";